import { isTechnicalPersonRowId } from '@/lib/personPublicationPathIds';

/**
 * Pick the person id that PersonProfile can resolve.
 * Outbox/API often sets person_id to a UUID while the stable key is a slug on person.person_id.
 */
export function getBestPersonProfileLinkId(source) {
  if (!source || typeof source !== 'object') return null;

  const candidates = [
    source.person?.person_id,
    source.person?.persona_id,
    source.person_id,
    source.persona_id,
    source.personId,
    source.person?.id,
    source.person?.persona_id,
  ]
    .map((v) => String(v ?? '').trim())
    .filter(Boolean);

  const seen = new Set();
  const unique = candidates.filter((c) => {
    if (seen.has(c)) return false;
    seen.add(c);
    return true;
  });

  const slug = unique.find((c) => !isTechnicalPersonRowId(c));
  return slug || unique[0] || null;
}
